import React from "react";
import { Grid, Button } from "@material-ui/core";
import SecurityIcon from '@material-ui/icons/Security';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { LockIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";
import DataContainer from "./dataContainer";

const buttonStyle = {
  backgroundColor: 'var(--secondaryBackgroundColor)',
  border: '1px solid var(--borderColor)',
  borderRadius: '30px',
  textTransform: "none",
  fontWeight: 600,
  padding: "8px 24px",
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
};

const UserFormHeader = (props) => {

  const {
    data,
    color,
    isVerticalStepper,
    onOpenDataProtection,
    onOpenCorrection,
    onOpenChangePin
  } = props;

  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      style={{
        marginTop: 20,
        padding: 15,
        background: "var(--tertiaryBackgroundColor)",
        border: "1px solid var(--borderColor)",
        borderRadius: 10,
      }}
    >
      <Grid container item xs={12} md={7} spacing={2}>
        <DataContainer
          label={getLocalizedString("employeeCode")}
          value={data["CODIGO DE EMPLEADO"]}
        />
        <DataContainer
          label={getLocalizedString("state")}
          value={data["ESTADO"]}
        />
        <DataContainer
          label={getLocalizedString("plantPersonnel")}
          value={data["PERSONAL DE PLANTA"]}
        />
      </Grid>
      <Grid container item xs={12} md={5} spacing={2} justify="flex-end" style={{ paddingTop: isVerticalStepper ? 20 : 0 }}>
        <Grid item>
          <Button
            className="whiteText"
            startIcon={<SecurityIcon htmlColor={color} />}
            onClick={onOpenDataProtection}
            style={buttonStyle}
          >
            {getLocalizedString("dataProtection")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            startIcon={<LockIcon htmlColor={color} />}
            onClick={onOpenChangePin}
            className="whiteText"
            style={buttonStyle}
          >
            {getLocalizedString("changingPin")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            startIcon={<ReportProblemIcon htmlColor={color} />}
            onClick={onOpenCorrection}
            style={buttonStyle}
          >
            {getLocalizedString("requestCorrection")}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserFormHeader;